export const GRADIENTS = {
  primary: 'linear-gradient(90deg, #5e1ff0 0%, #ce349a 100.17%)',
};
